//Just a simple funtion that will convert the
//date strings from the db into something more readable
import dayjs from 'dayjs'

export function format(dbString: string): string {
  const date = new Date(dbString)
  return dayjs(date).format('dddd[, ] MMMM DD[,] YYYY hh:mm a')
}

export function formatDateTime(date: string): string | undefined {
  if (date === '') {
    return undefined
  } else {
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
  }
}
export function formatDate(date: string): string | undefined {
  if (date === '') {
    return undefined
  } else {
    return dayjs(date).format('YYYY/MM/D HH:mm:ss')
  }
}
export function renderDateTime(dateObj: {
  value: Date | string
}): string | undefined {
  const date = dateObj.value
  if (!date || date === '') {
    return undefined
  } else {
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
  }
}
